import React, { useState } from "react";
import { motion } from "framer-motion";
import Contact_img from "../Assest/images/perfume2.webp";
import hero1 from "../Assest/images/hero1.jpg";
import toast, { Toaster } from "react-hot-toast";
import { FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import axios from "axios";

const Contact = () => {
  const [appointmentdata, setAppointmentdata] = useState({
    email: '',
    companyId: 13,
    date: new Date().toISOString().split('T')[0],
    time: new Date().toLocaleTimeString(),
  })

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    companyId: 13
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAppointmentChange = (e) => {
    setAppointmentdata({ ...appointmentdata, [e.target.name]: e.target.value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/contact/create`, formData);
      console.log(response.data);
      toast.success("Your message has been received. We will contact you shortly.");
      
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        companyId: 13
      });
      
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      toast.error("Failed to create contact");
    }
  };

  const handleAppointmentSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/appointment/create`, appointmentdata);
      console.log(response.data);
      toast.success("Your appointment has been successfully scheduled.");

      setAppointmentdata({
        email: '',
        companyId: 13,
        date: new Date().toISOString().split('T')[0],
        time: new Date().toLocaleTimeString(),
      });

    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      toast.error("Failed to create contact");
    }
  };


  return (
    <div className="w-full overflow-hidden">
      {/* Hero Section with Background Image */}
      <section className="w-full h-[500px] relative mt-16">
        <motion.div
          key={1}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="w-full h-full"
        >
          {/* Background Image */}
          <img
            src={Contact_img}
            alt="Background"
            className="w-full h-full object-cover"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* Centered Content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center z-10">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-6xl font-bold mb-4"
            >
              Contact Us
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-lg md:text-xl max-w-2xl px-4"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </motion.p>
          </div>
        </motion.div>
      </section>

      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 space-y-16">
        {/* Form and Newsletter Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Contact Form */}
          <div className="lg:col-span-2">
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  onChange={handleChange}
                  value={formData.name}
                  type="text"
                  placeholder="Name"
                  name='name'
                  className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
                />
                <input
                  onChange={handleChange}
                  value={formData.email}
                  type="email"
                  required
                  name="email"
                  placeholder="Email"
                  className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
                />
              </div>
              <input
                onChange={handleChange}
                value={formData.subject}
                name="subject"
                type="text"
                required
                placeholder="Subject"
                className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
              />
              <textarea
                onChange={handleChange}
                placeholder="Message"
                value={formData.message}
                name="message"
                rows="4"
                required
                className="w-full p-3 rounded-md bg-orange-50 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus-visible:ring-orange-500 focus:border-transparent"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-orange-500 text-white rounded-md hover:bg-orange-700 transition-colors"
              >
                Submit Button
              </button>
            </form>
          </div>

          {/* Newsletter */}
          <div className="relative bg-orange-100 p-6 rounded-lg text-gray-800 overflow-hidden">
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 z-0">
              <img
                src={hero1} // Replace with your image path
                alt=""
                className="w-full h-full object-cover opacity-10"
              />
            </div>

            {/* Content */}
            <div className="relative z-10">
              <h3 className="text-xl font-bold mb-3">Our Newsletters</h3>
              <p className="mb-4 text-sm">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
                tellus, luctus nec.
              </p>
              <form onSubmit={handleAppointmentSubmit}>
                <input
                  onChange={handleAppointmentChange}
                  value={appointmentdata.email}
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  className="w-full p-3 rounded-md bg-white text-gray-800 mb-3 border-0 outline-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                />
                <button
                  type="submit"
                  className="w-full p-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors"
                >
                  Submit Button
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-[#F5F8F8] p-6 rounded-lg flex items-start gap-4">
            <FaPhone className="text-orange-500 text-xl mt-1" />
            <div>
              <h4 className="font-bold">(+4476) 755 555</h4>
              <p className="text-sm text-gray-600">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
            </div>
          </div>

          <div className="bg-[#F5F8F8] p-6 rounded-lg flex items-start gap-4">
            <FaEnvelope className="text-orange-500 text-xl mt-1" />
            <div>
              <h4 className="font-bold">mail@influence.id</h4>
              <p className="text-sm text-gray-600">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
            </div>
          </div>

          <div className="bg-[#F5F8F8] p-6 rounded-lg flex items-start gap-4">
            <FaMapMarkerAlt className="text-orange-500 text-xl mt-1" />
            <div>
              <h4 className="font-bold">London Eye London</h4>
              <p className="text-sm text-gray-600">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="w-full h-[400px] rounded-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.537431086829!2d-0.12047108459469316!3d51.50332197963573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604c7c7eb9be3%3A0x3918653583725b56!2sLondon%20Eye!5e0!3m2!1sen!2suk!4v1635000000000!5m2!1sen!2suk"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          />
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default Contact;